import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@chakra-ui/react";
import { Checkbox } from "../../../atoms";
export const paddingTopCalc = ({ row, offset, }) => (row.start ? row.start - offset : 0 - offset);
export const paddingBottomCalc = ({ row, totalSize, }) => (row.end ? totalSize - row.end : totalSize);
export const getSortIcon = (direction) => {
    if (direction === "asc") {
        return "clickableSortingUp24";
    }
    if (direction === "desc") {
        return "clickableSortingDown24";
    }
    return "clickableSortingNeutral24";
};
export const selectionColumn = {
    id: "select",
    sticky: "left",
    header: ({ table }) => (_jsx(Checkbox, { isChecked: table.getIsAllRowsSelected(), isIndeterminate: table.getIsSomeRowsSelected(), onChange: table.getIsSomeRowsSelected()
            ? () => {
                table.resetRowSelection();
            }
            : table.getToggleAllRowsSelectedHandler() })),
    cell: ({ row }) => (_jsx(Box, Object.assign({ onClick: (e) => e.stopPropagation() }, { children: _jsx(Checkbox, { isChecked: row.getIsSelected(), isDisabled: !row.getCanSelect(), isIndeterminate: row.getIsSomeSelected(), onChange: row.getToggleSelectedHandler() }) }))),
    size: 72,
};
//# sourceMappingURL=index.js.map